import { render } from "./PbProjectsSearch.vue?vue&type=template&id=74d2b986"
import script from "./PbProjectsSearch.vue?vue&type=script&lang=js"
export * from "./PbProjectsSearch.vue?vue&type=script&lang=js"

import "./PbProjectsSearch.vue?vue&type=style&index=0&id=74d2b986&lang=scss"

import exportComponent from "/home/runner/work/project-booster--collaborator/project-booster--collaborator/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__